import { defaultInitialState, loadingState, getErrorState, defaultApiState } from '../utils';
import { GET_CAREGIVERS, GET_CAREGIVERS_DONE, GET_CAREGIVERS_ERROR, RESET_CAREGIVERS } from './actionTypes';
const initialState = Object.assign(Object.assign({}, defaultInitialState), { data: [] });
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CAREGIVERS:
            return Object.assign(Object.assign({}, state), { loadingState });
        case GET_CAREGIVERS_DONE:
            return Object.assign(Object.assign(Object.assign({}, state), defaultApiState), { data: action.data });
        case GET_CAREGIVERS_ERROR:
            return Object.assign(Object.assign({}, state), getErrorState(action.errorMessage));
        case RESET_CAREGIVERS:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map